var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carret"},[(_vm.open)?_c('span',[_vm._v("⏶")]):_vm._e(),(!_vm.open)?_c('span',[_vm._v("⏷")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }